module.exports = __webpack_public_path__ + "static/media/cause-culture.0dec3dec.jpg";